<template>
  <div>
    <div class="uploadbox-head"  v-if="showHead">
      <span v-if="required" class="required-icon">*</span>
      <span class="title">{{ title || $lang("附件") }}</span>
      <span v-if="decs">{{ decs }}</span>
      <span v-else>{{
        $lang("（单个文件{0}M内，最多上传{1}个附件,支持格式{2}）")
          .replace("{0}", size)
          .replace("{1}", limit)
          .replace("{2}", typeName)
      }}</span>
    </div>
    <div class="row" style="margin-top: -5px">
      <BatchUpload
        ref="imgUploadRef"
        uploadKey="fileList"
        isAll
        :option="{
          uploadApi,
          ...option,
        }"
        :uploadTips="uploadTips"
        :multiple="true"
        :limit="limit"
        :fileSize="size"
        :list="paths"
        :fileTypeList="fileTypeList"
        @uploadSuccess="uploadSuccess"
        @uploadStart="attaUploadStart"
        :isView="isView"
      />
      <input class="picture-img" hidden auto-complete="off" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paths: this.value,
      isUploadSuccess: false,
      uploadApi: `bpo/file/getUploadSignedUrl`
    };
  },
  props: {
    title: String,
    required: Boolean,
    limit: {
      type: Number,
      default: 3
    },
    size: {
      type: Number,
      default: 50
    },
    fileTypeList: {
      type: Array,
      default: () => [
        'jpg',
        'png',
        'jpeg',
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'zip',
        'rar'
      ]
    },
    decs: {
      type: String,
      default: ''
    },
    value: Array,
    uploadTips: {
      type: Boolean,
      default: false
    },
    showHead: {
      type: Boolean,
      default: true
    },
    api: {
      type: String,
      default: ''
    },
    moduleCode: {
      type: Number,
      default: () => ''
    },
    // 配置项
    option: {
      type: Object,
      default() {
        return {
          projectName: '',
          moduleName: '',
          uploadApi: '',
          fileNames: ''
        };
      }
    },
    isView: {
      type: Boolean,
      default: () => false
    }
  },
  created() {
    // 获取api
    if (this.api) {
      this.uploadApi = this.api;
    }
  },
  computed: {
    typeName() {
      return this.fileTypeList.map((o) => o.toUpperCase()).join('/');
    }
  },
  methods: {
    uploadSuccess(list) {
      console.log(list, 'list')
      this.isUploadSuccess = true;
      this.paths = list;
      this.$emit('isUploadSuccess', this.isUploadSuccess);
      this.$emit('input', list);
      console.log(this.isUploadSuccess, this.paths, 'isUploadSuccess')
    },
    attaUploadStart() {
      this.isUploadSuccess = false;
      this.$emit('isUploadSuccess', this.isUploadSuccess);
    }
  },
  watch: {
    value: {
      deep: true,
      handler(paths) {
        this.paths = paths;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.uploadbox-head {
  word-break: break-all;
  padding: 7px 0;
  line-height: 18px;
  @include text-color("subtitle");
  span {
    font-size: 12px;
    // font-family: MicrosoftYaHei;
    @include text-color("routine");
  }
  .title {
    font-size: 14px;
    font-weight: bold;
    @include text-color("main");
  }
  .required-icon {
    color: #f56c6c;
    font-size: 14px;
    margin-right: 5px;
  }
}
</style>
